import type { LanguageKey } from '@atlassian/jira-servicedesk-language-settings-translations-resource/src/services/get-data/types.tsx';
import type { TranslationPanelMap, TranslationPanelState } from '../../common/types';
import type { LanguageTranslationsSavePayload } from '../save-data/types';

export const buildTranslationsSaveDataPayload = ({
	selectedPanelId,
	translationPanelMap,
	currentLanguage,
}: {
	selectedPanelId: string;
	translationPanelMap: TranslationPanelMap;
	currentLanguage: LanguageKey;
}): LanguageTranslationsSavePayload => {
	const selectedPanelData: TranslationPanelState = translationPanelMap[selectedPanelId];
	const { entityId, providerKey, translationGroups, displayName } = selectedPanelData;

	const fieldUpdates = translationGroups.flatMap((tGroup) =>
		tGroup.translationFields.map((tField) => {
			const { logicalId, changeType, translationContentMap } = tField;
			const content = translationContentMap[currentLanguage];

			return {
				logicalId,
				changeType,
				content,
			};
		}),
	);

	return {
		languageTag: currentLanguage,
		panelTitle: displayName,
		entityId,
		providerKey,
		fieldUpdates,
	};
};
